// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.client.moodys.enums.CustomerAnalyticsUnitMixConfigType

export enum CustomerAnalyticsUnitMixConfigType {
  ONE_BEDROOM = 'ONE_BEDROOM',
  STUDIO = 'STUDIO',
  THREE_OR_MORE_BEDROOM = 'THREE_OR_MORE_BEDROOM',
  TWO_BEDROOM = 'TWO_BEDROOM',
}

export const CustomerAnalyticsUnitMixConfigType_values = [
  CustomerAnalyticsUnitMixConfigType.ONE_BEDROOM,
  CustomerAnalyticsUnitMixConfigType.STUDIO,
  CustomerAnalyticsUnitMixConfigType.THREE_OR_MORE_BEDROOM,
  CustomerAnalyticsUnitMixConfigType.TWO_BEDROOM,
] as const;
